import { useTranslations } from '@vocab/react';
import { Button, IconArrow } from 'braid-design-system';

import translations from './.vocab';

export const BackButton = ({
  onBackButtonClicked,
}: {
  onBackButtonClicked: () => void;
}) => {
  const { t } = useTranslations(translations);

  return (
    <Button
      icon={<IconArrow direction="left" />}
      variant="soft"
      onClick={onBackButtonClicked}
      data={{ testid: 'page-level-back-button' }}
    >
      {t('pay-post-page-link-text')}
    </Button>
  );
};
